import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * `cn` — concatena classi Tailwind risolvendo i conflitti (es. `p-2 p-4` → `p-4`).
 * Usato dai componenti shadcn/ui e ovunque servano classi condizionali.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
